import React from "react";
import { motion } from "framer-motion";
import { TrendingDown, ShieldCheck, Zap } from "lucide-react";

const GOALS = [
  {
    id: "bills",
    title: "Réduire mes factures",
    icon: <TrendingDown className="h-6 w-6" />,
    bg: "bg-[#E6F4EA]",
    fg: "text-[#2D7A4D]",
  },
  {
    id: "resilience",
    title: "Gagner en autonomie",
    icon: <ShieldCheck className="h-6 w-6" />,
    bg: "bg-[#FFF3E0]",
    fg: "text-[#E65100]",
  },
  {
    id: "electrify",
    title: "Électrifier ma maison",
    icon: <Zap className="h-6 w-6" />,
    bg: "bg-[#E3F2FD]",
    fg: "text-[#1E88E5]",
  },
];

export default function GoalsQuiz() {
  const scroll = () =>
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      id="objectifs"
      className="py-24 lg:py-32 bg-[#FDFBF7]"
      data-testid="goals-section"
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="eyebrow mb-4"
          >
            Le quiz · En 30 secondes
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-serif-display font-medium text-[36px] sm:text-[52px] lg:text-[68px] leading-[1] tracking-tight text-[#0F172A] balance"
          >
            Dites-nous ce que vous voulez atteindre.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="mt-5 text-[16px] leading-relaxed text-[#334155] max-w-xl"
          >
            Selon votre objectif, on vous oriente vers la meilleure combinaison
            de solutions. Une réponse claire, sans langue de bois.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
          {GOALS.map((g, i) => (
            <motion.button
              key={g.id}
              onClick={scroll}
              data-testid={`goal-card-${g.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group text-left rounded-3xl bg-[#F5F1EA] border border-[#e2d9ce] p-8 lg:p-10 aspect-[4/3] flex flex-col justify-between hover:border-[#0F172A] transition-colors card-tilt"
            >
              <div className={`h-14 w-14 rounded-full ${g.bg} ${g.fg} flex items-center justify-center`}>
                {g.icon}
              </div>
              <div>
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-[#64748B] mb-3">
                  Objectif {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-serif-display text-3xl lg:text-4xl text-[#0F172A] leading-[1.02]">
                  {g.title}
                </h3>
                <div className="mt-6 inline-flex items-center gap-1.5 text-sm text-[#2D7A4D] font-medium">
                  Sélectionner
                  <span className="transition-transform group-hover:translate-x-1">→</span>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
